import { IS_LOCALHOST } from './config';
import { webEventProxyUrl } from 'hatchEndpoints';
export async function SendEvent( token, eventData, topicName ) {
    // Ignore sending real events if its local.
    if ( IS_LOCALHOST ) {
        return;
    }
    try {
        const response = await fetch( `${ webEventProxyUrl }/topics`, {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${ token }`,
                'content-type': 'application/json'
            },
            body: JSON.stringify( {
                eventData,
                topicName
            } )
        } );

        const data = await response.json();
        return data;
    } catch ( err ) {
        console.log( err );
        throw new Error( err );
    }
}